import Vue from 'vue';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/styles/custom.scss';

const {
  VUE_APP_API_BASE,
  VUE_APP_WEBSITE_BASE,
} = process.env;

const moment = require('moment');
require('moment/locale/sv');
Vue.use(require('vue-moment'), {
  moment,
});

Vue.use(BootstrapVue);
Vue.use(VueClipboard);

/**
 * AXIOS
 */
const base = axios.create({
  baseURL: VUE_APP_API_BASE,
});

Vue.config.productionTip = false;
Vue.prototype.$http = base;
Vue.prototype.WEBSITE_BASE = VUE_APP_WEBSITE_BASE;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    const { token } = this.$route.query;
    if (token) {
      store.commit({
        type: 'updateToken',
        token,
      });
    }
  },
}).$mount('#app');
